export default "__VITE_ASSET__VEJ6q56G__"